import debug, { DEBUG } from '../util/debug';
function request(URL) {
    return fetch(URL)
        .then((response) => response.json())
        .then((data) => data);
}
export async function fetchNonRegisteredVendorList(baseURL, version) {
    const url = `${baseURL}/nrv/${version}/vendor-list.json`;
    debug(`fetching nrv: ${url}`, DEBUG);
    const resp = await request(url);
    return resp.map(({ provider_id, provider_name, policy_url }) => ({
        id: provider_id,
        name: provider_name,
        policyUrl: policy_url,
    }));
}
export async function fetchNonTCFRegisteredVendorList(baseURL, version) {
    const url = `${baseURL}/custom/${version}/vendor-list.json`;
    debug(`fetching cvl: ${url}`, DEBUG);
    const resp = await request(url);
    return resp.map(({ provider_id, provider_name, policy_url }) => ({
        id: provider_id,
        name: provider_name,
        policyUrl: policy_url,
    }));
}
export const fetchGVL = async (baseURL, version) => {
    const url = `${baseURL}/gvl/${version}/vendor-list.json`;
    debug(`fetching GVL: ${url}`, DEBUG);
    const { features, vendorListVersion, lastUpdated, purposes, vendors } = await request(url);
    return {
        features: Object.values(features).map(({ id, name, description }) => ({
            id,
            name,
            description,
        })),
        vendorListVersion,
        lastUpdated,
        purposes: Object.values(purposes).map(({ id, name, description }) => ({
            id,
            name,
            description,
        })),
        vendors: Object.values(vendors).map(({ id, name, policyUrl, deletedDate, features, legIntPurposes, purposes, }) => ({
            id,
            name,
            policyUrl,
            deletedDate,
            featureIds: features,
            legIntPurposeIds: legIntPurposes,
            purposeIds: purposes,
        })),
    };
};
